import { TASK_RESPONSIBILITY } from 'shared/common/enums'

export const isResponsibilityInternal = (arg: any) =>
  arg === TASK_RESPONSIBILITY.internal

export const isResponsibilityCustomer = (arg: any) =>
  arg === TASK_RESPONSIBILITY.customer

export const isResponsibilityThirdParty = (arg: any) =>
  arg === TASK_RESPONSIBILITY.thirdParty
